(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gmc-payment-request"] && !Shopify.designMode) return;
  try {
    (function () {
  function prefill() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('gmc_request') !== 'payment') return;
    var context = document.querySelector('[data-gmc-payment-request]');
    var field = document.querySelector('form textarea[name="contact[body]"]');
    var title = params.get('mask');
    var path = params.get('mask_path');
    if (!context || !field || field.value.trim() || !title || !path) return;
    var url;
    try { url = new URL(path, window.location.origin); } catch (error) { return; }
    if (url.origin !== window.location.origin || !url.pathname.startsWith('/products/')) return;
    var message = params.get('gmc_plan') === 'special' ? context.dataset.specialMessage : context.dataset.message;
    field.value = message + '\n\n' + title.slice(0, 500) + '\n' + url.href;
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.form.scrollIntoView({ block: 'center' });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prefill);
  else prefill();
}());
  } catch(e) { console.error(e); }
})();

})();
